import { StorefrontModule } from '@vue-storefront/core/lib/modules';
import { extendStore } from '@vue-storefront/core/helpers';
import { PRODUCT_TYPE } from 'src/modules/gift-card/constants';

const checkoutModule = {
  getters: {
    isVirtualCart: ({ cartItems }) => cartItems.length ? cartItems.every(itm => itm.type_id === 'downloadable' || itm.type_id === 'virtual' || itm.type_id === 'configurable' || itm.type_id === PRODUCT_TYPE) : false
  }
}

export const Evenemangsbiljetter: StorefrontModule = function () {
  extendStore('cart', checkoutModule);
}
